import { useEffect, useState } from "react";

const useDeviceDetect = () => {
  const [isDesktop, setIsDesktop] = useState(
    window.matchMedia("(min-width: 1200px)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1200px)");

    const handler = (e:any) => setIsDesktop(e.matches);

    mediaQuery.addEventListener("change", handler);

    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  return { isDesktop };
};

export default useDeviceDetect;